<template>
  <button type="button" class="button-color h-6 w-6">
    <!-- prettier-ignore -->
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="m10 19-7-7m0 0 7-7m-7 7h18"/></svg>
  </button>
</template>

<script lang="ts" setup></script>

<style scoped>
  .button-color {
    color: var(--return-button-color, rgb(var(--situational-black)));
  }
</style>
